import Cookies from 'js-cookie';
import axios from './axios';

export const getChartPenjualanProduk = (tipe: string, value: string) => {
  return axios.get(`/admin/pesanan/chart/penjualan/produk?tipe=${tipe}&value=${value}`);
};

export const getChartPenjualanKategori = (tipe: string, value: string) => {
  return axios.get(`/admin/pesanan/chart/penjualan/kategori?tipe=${tipe}&value=${value}`);
};

export const getReportPenjualanProduk = (
  params: any,
  page: number = 1,
  tipe: string,
  value: string = null,
) => {
  if (params)
    return axios.get(
      `/admin/pesanan/laporan/data?${params}&page=${page}&tipe=${tipe}&value=${value}`,
    );
  return axios.get(
    `/admin/pesanan/laporan/data?page=${page}&tipe=${tipe}&value=${value}`,
  );
};

export const getExportReportPenjualanProduk = (tipe: string, value: string) => {
  return `${
    process.env.REACT_APP_BASE_URL_API
  }/admin/pesanan/laporan/export?tipe=${tipe}&value=${value}&token=${Cookies.get(
    process.env.REACT_APP_ACCESS_TOKEN!,
  )}`;
};
